/**
 * @author gll
 * 模块说明：采购定价
 */
import { Service } from '@/tools'

export class fixedPriceConfigService<T extends TProcure.fixedPriceConfig> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.fixedPriceConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：分页查询优先级配置列表
   * /api/procure/fixedPriceConfig/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：优先级配置查看
   * /api/procure/fixedPriceConfig/v1/queryConfig
   */
  queryConfig = <K extends T['ApiQueryConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryConfig', data)
  }

  /**
   * 模块说明：新增优先级配置
   * /api/procure/fixedPriceConfig/v1/config
   */
  config = <K extends T['ApiConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiConfig', data)
  }

  /**
   * 模块说明：生效优先级配置
   * /api/procure/fixedPriceConfig/v1/startConfig
   */
  startConfig = <K extends T['ApiStartConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiStartConfig', data, '操作成功')
  }

  /**
   * 模块说明：失效优先级配置
   * /api/procure/fixedPriceConfig/v1/enableConfig
   */
  enableConfig = <K extends T['ApiEnableConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiEnableConfig', data, '操作成功')
  }

  /**
   * 模块说明：删除优先级配置
   * /api/procure/fixedPriceConfig/v1/deleteConfig
   */
  deleteConfig = <K extends T['ApiDeleteConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDeleteConfig', data, '操作成功')
  }

  /**
   * 模块说明：查询默认配置
   * /api/procure/fixedPriceConfig/v1/findDefaultConfig
   */
  findDefaultConfig = <K extends T['ApiFindDefaultConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiFindDefaultConfig', data)
  }

  /**
   * 模块说明：新增默认优先级配置
   * /api/procure/fixedPriceConfig/v1/addDefaultConfig
   */
  addDefaultConfig = <K extends T['ApiAddDefaultConfig']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAddDefaultConfig', data, '操作成功')
  }
}
